// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1wYWW","infoBtn":"quickbooks_infoBtn__37_Jr","formBox":"quickbooks_formBox__1MB-a","formFooter":"quickbooks_formFooter___3SKq"};